<template>
    <div class="filter">
        <div class="button filter__button" :class="filterClasses" @click="handleClick($event)">
            <template v-if="chooseFilter">
                <div class="filter__button__icon">
                    <vector-icon icon="filter-list" :size="[16, 13]" fill="#7A7A7A" />
                </div>
                <span>{{ chooseFilter.name }}</span>
                <div class="filter__buttonClose" @click="handleClearSegmentFilter($event)">
                    <fa-icon :icon="['far', 'times']" />
                </div>
            </template>
            <template v-else>
                <div class="filter__button__icon">
                    <vector-icon icon="filter-list" :size="[16, 13]" fill="#7A7A7A" />
                </div>
                <span>Filter</span>
                <span v-if="filterSelected" class="filter__count">
                    <span>{{ filterSelected }}</span>
                </span>
            </template>
        </div>

        <template v-if="show">
            <filter-container-segments
                v-if="showSegments"
                :filterSegments="filterSegments"
                :hasModal="hasModal"
                @handle-new-segment="handleNewSegment"
                @handle-choose-segment-filter="handleChooseSegmentFilter"
                @handle-update-segment-filter="handleUpdateSegmentFilter"
            />
            <template v-else>
                <template v-if="hasModal">
                    <filter-modal
                        :dropdownClass="dropdownClass"
                        :name="name"
                        :show="show"
                        :loading="loading"
                        :filtersList="filtersList"
                        :filtersData="filtersData"
                        :loadingSend="loadingSend"
                        :isFilterEmpty="isFilterEmpty"
                        :hasModal="hasModal"
                        :form="form"
                        :totalContactsToBroadcast="totalContactsToBroadcast"
                        :filterSelected="filterSelected"
                        :disableScroll="disableScroll"
                        :typeSegment="typeSegment"
                        :chooseFilter="chooseFilter"
                        :isFirstFilterIntegration="isFirstFilterIntegration"
                        @clear="clear"
                        @remove-filter="removeFilter"
                        @add-filter="addFilter"
                        @add-list="addList"
                        @closed="handleChangeStatusModal"
                        @apply-filter="applyFilter"
                        @change-value-filter="changeValueFilter"
                        @handle-open-save-segment-modal="handleOpenSaveSegmentModal"
                        @handle-change-type-segment="handleChangeTypeSegment"
                        @handle-change-loading-send="handleChangeLoadingSend"
                    />
                </template>
                <template v-else>
                    <filter-container
                        :dropdownClass="dropdownClass"
                        :loading="loading"
                        :filtersList="filtersList"
                        :filtersData="filtersData"
                        :loadingSend="loadingSend"
                        :isFilterEmpty="isFilterEmpty"
                        :filterSelected="filterSelected"
                        :filtersValues="filtersValues"
                        :disableScroll="disableScroll"
                        :name="name"
                        :disableSegment="name !== 'triggers' && name !== 'broadcastsPage'"
                        :typeSegment="typeSegment"
                        :chooseFilter="chooseFilter"
                        @clear="clear"
                        @remove-filter="removeFilter"
                        @add-filter="addFilter"
                        @add-list="addList"
                        @closed="handleChangeStatusModal"
                        @apply-filter="applyFilter"
                        @change-value-filter="changeValueFilter"
                        @handle-open-save-segment-modal="handleOpenSaveSegmentModal"
                        @handle-change-type-segment="handleChangeTypeSegment"
                        @handle-change-loading-send="handleChangeLoadingSend"
                    />
                </template>
            </template>
        </template>

        <filter-segment-modal
            :show="showSegmentModal"
            :typeSegment="typeSegment"
            :chooseFilter="chooseFilter"
            @closed="handleOpenSaveSegmentModal"
            @handle-save-segment="handleSaveSegment"
            @handle-update-segment="handleUpdateSegment"
            @handle-delete-segment="handleDeleteSegment"
        />
    </div>
</template>

<script>
import FilterContainer from './FilterContainer';
import FilterContainerSegments from './FilterContainerSegments';
import FilterModal from './FilterModal';
import FilterSegmentModal from './FilterSegmentModal';
import MixinMultipleFilter from '../../mixins/multiple-filter';

export default {
    components: {
        FilterContainer,
        FilterModal,
        FilterContainerSegments,
        FilterSegmentModal,
    },

    mixins: [MixinMultipleFilter],

    props: {
        name: { type: String, default: '' },
        dropdownClass: { type: String, default: '' },
        hasTag: { type: Boolean, default: false },
        disableSegments: { type: Boolean, default: false },
        tags: { type: Array },
        hasModal: { type: Boolean, default: false },
        hasQuery: { type: Boolean, default: false },
        form: { type: Object },
        totalContactsToBroadcast: { type: Number },
        disableScroll: { type: Boolean, default: false },
        hasCheckPreview: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        isFirstFilterIntegration: { type: Boolean, default: false },
    },

    data() {
        return {
            window: window,
            show: false,
            filters: [],
            filtersData: null,
            loading: false,
            loadingSend: false,
            query: false,
            hasNewSegment: false,
            showSegmentModal: false,
            chooseFilter: null,
            typeSegment: 'create',
            edit: false,
            loadingFilters: false,
            emptyTagsArr: false,
            isIntegrationFirstFilter: false,
        };
    },

    mounted() {
        this.load();
        document.addEventListener('click', this.handleOutSideHide);
        this.$rootEvents.$on('handleClearFilters', this.handleClearFilters);
        this.$rootEvents.$on(
            'handleIsFirstFilterIntegrationFilterItem',
            this.handleIsFirstFilterIntegration
        );
        this.$rootEvents.$on('handleBulkTags', this.initFiltersData);
    },

    destroy() {
        document.removeEventListener('click', this.handleOutSideHide);
        this.$rootEvents.$off('handleClearFilters', this.handleClearFilters);
        this.$rootEvents.$off(
            'handleIsFirstFilterIntegrationFilterItem',
            this.handleIsFirstFilterIntegration
        );
        this.$rootEvents.$off('handleBulkTags', this.initFiltersData);
    },
};
</script>
